/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svr_Guidance_Onsite_4Inputs */

const en_svr_guidance_onsite_4 = /** @type {(inputs: Svr_Guidance_Onsite_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Additional engineer or specific skills needed?`)
};

const ja_svr_guidance_onsite_4 = /** @type {(inputs: Svr_Guidance_Onsite_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`追加のエンジニアや特殊なスキルは必要ですか？`)
};

const fr_svr_guidance_onsite_4 = /** @type {(inputs: Svr_Guidance_Onsite_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingénieur supplémentaire ou compétences spécifiques nécessaires ?`)
};

const de_svr_guidance_onsite_4 = /** @type {(inputs: Svr_Guidance_Onsite_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zusätzlicher Techniker oder spezielle Fähigkeiten erforderlich?`)
};

/**
* | output |
* | --- |
* | "Additional engineer or specific skills needed?" |
*
* @param {Svr_Guidance_Onsite_4Inputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const svr_guidance_onsite_4 = /** @type {((inputs?: Svr_Guidance_Onsite_4Inputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svr_Guidance_Onsite_4Inputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_svr_guidance_onsite_4(inputs)
	if (locale === "ja") return ja_svr_guidance_onsite_4(inputs)
	if (locale === "fr") return fr_svr_guidance_onsite_4(inputs)
	return de_svr_guidance_onsite_4(inputs)
});